export const WEBINAR_LATE_JOIN_BUFFER_MS = 30 * 60 * 1000;
const DEFAULT_WEBINAR_DURATION_MS = 2 * 60 * 60 * 1000;

export function parseApiDateAsUtc(dateStr: string): Date {
  const hasTimeZone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(dateStr);
  return new Date(hasTimeZone ? dateStr : `${dateStr}Z`);
}

export function getWebinarStartTime(startDate?: string): number | null {
  if (!startDate) return null;
  return parseApiDateAsUtc(startDate).getTime();
}

export function getWebinarEndTime(startDate?: string, endDate?: string): number | null {
  if (endDate) return parseApiDateAsUtc(endDate).getTime();
  const start = getWebinarStartTime(startDate);
  if (start == null) return null;
  return start + DEFAULT_WEBINAR_DURATION_MS;
}

export function isWebinarStartWithinBuffer(
  startDate?: string,
  nowMs = Date.now(),
  bufferMs = WEBINAR_LATE_JOIN_BUFFER_MS
): boolean {
  const start = getWebinarStartTime(startDate);
  return start != null && start >= nowMs - bufferMs;
}

export function hasWebinarEnded(startDate?: string, endDate?: string, nowMs = Date.now()): boolean {
  const end = getWebinarEndTime(startDate, endDate);
  return end != null && nowMs > end;
}
